module.exports = __webpack_public_path__ + "b8d8c22556ee38c48786213227e3077d.svg";